module.exports = __webpack_public_path__ + "static/media/suggestions.70f8a766.png";